<div
	class="obg-m-deposit-limit-calculator-result-container"
	*ngIf="calculation"
	test-id="deposit-limit-calculator-result"
	data-test-id="deposit-limit-calculator-result"
>
	<h4 [innerHTML]="calculation?.header"></h4>

	<div class="calculation-value" data-test-id="calculation-value">
		<p class="recap">{{ calculation.data?.recap }}</p>
		<p class="result">{{ calculation.data?.result }}</p>
	</div>
</div>

<button
	class="reset"
	(click)="reset.emit()"
	mat-flat-button
	color="accent"
	test-id="deposit-limit-calculator-calculate-again"
	data-test-id="deposit-limit-calculator-calculate-again"
>
	{{ "deposit-limit-calculator.calculate-again" | translate }}
</button>
